import React from 'react'
import { Typography } from '@material-ui/core'
import { Variant } from '@material-ui/core/styles/createTypography'
import { DomParser } from './domParser'

export const headings: DomParser = (element, props) => {
  return <Typography { ...props } variant={element.name as Variant} />
}

headings.match = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']